export default "__VITE_ASSET__BCBwgnqu__"